export const colors = {
    green: "#8FAD80",
    yellow: "#E6C451",
    orange: "#E7922C",
    turquoise: "#89B3A5",
};
